import CompoundCoursePart from "@/models/CompoundCoursePart";
import CourseRun from "@/models/CourseRun";
import LiveCourseParticipant from "@/models/LiveCourseParticipant";
import BuyCourseParticipant from "@/models/BuyCourseParticipant";

export default class BuyCourseDate {
    constructor(raw = {}) {
        this.id = raw.id;
        this.date = raw.date;
        this.end = raw.end;
        this.participants = raw.participants.map((item) => new BuyCourseParticipant(item));

        let anyWaiting = this.participants.find((item) => item.state === 'WAITING');

        this.applicantsWaiting = anyWaiting !== undefined && anyWaiting !== null
    }


}

